// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb24408a","453":"c4b6ad54","732":"9a8b6a8c"}[chunkId] + ".chunk.js";
};